module.exports = __webpack_public_path__ + "img/parc2.6a79c333.png";